const strings = {
  deviceSettings: {
    devices: (deviceAmt: number) => `Devices (${deviceAmt})`,
    location: "Location",
    lastUpdate: "Last Update",
    watering: "Watering",
    deviceNotes: "Device Notes",
    getMoreDevices: "Add Device",
    modal: {
      locationSuccessTitle: "Device location updated",
      locationSuccessMessage: (deviceName: string, locationName: string) =>
        `${deviceName} is now set to the location: ${locationName}. You can now filter this device by the set location.`,
      locationErrorTitle: "Unable to Update Device Location",
      locationErrorMessage: (deviceName: string) =>
        `There was an issue updating the location for ${deviceName}. Please try again later.`,
      notesSuccessTitle: "Device notes updated",
      notesSuccessMessage: (deviceName: string) =>
        `Notes for ${deviceName} have been saved and updated. You can now view the updated notes on the device view.`,
      notesErrorTitle: "Unable to Update Device Notes",
      notesErrorMessage: (deviceName: string) =>
        `There was an issue updating the notes for ${deviceName}. Please try again later.`,
    },
  },
};

export default strings;
